import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import debounce from 'lodash/debounce';
import { Card, Grid } from '@mui/material';
import ActionsPopover from 'components/ActionsPopover/ActionsPopover';

import MDBox from 'components/MDBox';
import MDButton from 'components/MDButton';
import MDTypography from 'components/MDTypography';
import DataTable from 'examples/Tables/DataTable';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

import {
  getNotificationsList,
  addEmail,
} from '../../store/reducers/usersSlice';
import PreviewEmail from './components/PreviewEmail';
import {emailColumns} from 'constants/columns.constants';
import { CleaningServices } from '@mui/icons-material';
import AddEmail from 'layouts/email/components/AddEmail';
import moment from 'moment';

const Email = () => {
  const [isLoading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { notifications } = useSelector((state) => state.usersSlice);
  const [selectedEmail, setSelectedEmail] = useState(null);
  const [openModal, setOpenModal] = useState(false);;
  const [isPreviewModal, setPreviewModal] = useState(false);

  const [currentPage, setCurrentPage] = useState(0);
  const [perPage, setPerPage] = useState(10);

  const columns = useMemo(() => {
    return emailColumns;
  }, []);

  const rows =
  notifications?.notificationsData?.length > 0
      ? notifications?.notificationsData?.map((faq) => {
          return {
            id:faq?.id,
            subject: (
              <div style={{ maxWidth: 'max(calc(100vw - 650px), 20ch)' }}>
                {faq?.subject?? 'NA'}
              </div>
            ),
            date: (
              <div style={{ maxWidth: 'max(calc(100vw - 650px), 20ch)' }}>
                {moment(faq?.date?? 'NA').format('MM/DD/YYYY h:mm a')}
              </div>
            ),
            priorityIndex: faq?.priorityIndex ?? 'NA',
            actions: (
              <ActionsPopover
                viewTitle={'View Email'}
                onViewClick={(viewEmail) => {
                  setSelectedEmail(faq);
                  setPreviewModal(true);
                }}
              />
            ),
          };
        })
      : [];

  async function fetchEmailList() {
    try {
      setLoading(true);
      await dispatch(
        getNotificationsList({
          page: currentPage + 1,
          limit: perPage,
          type:'email'
        })
      );
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }

  const onCloseModal = () => {
    setSelectedEmail(null);
    setOpenModal(false);
    setPreviewModal(false);
  };

  const onCreateEmail = async (data) => {
    try {
      await dispatch(
        addEmail({
          ...data,
          
        })
      );
      onCloseModal();
      if (currentPage === 0) {
        fetchEmailList();
      } else {
        setCurrentPage(0);
      }
    } catch (error) {

    }
  };

  const onFetchDataDebounced = debounce(fetchEmailList, 0);

  useEffect(() => {
    onFetchDataDebounced();

    return () => {
      onFetchDataDebounced.cancel();
    };
  }, [currentPage, perPage]);

  return (
    <MDBox pt={6} pb={3}>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Email
              </MDTypography>
              <MDButton
                sx={{ marginLeft: 'auto', marginRight: '16px' }}
                variant="outlined"
                startIcon={<AddCircleOutlineIcon />}
                onClick={() => setOpenModal(true)}
              >
                Add Email
              </MDButton>
            </MDBox>
            <MDBox
              sx={{
                position: 'relative',
                paddingTop: '85px',
                paddingBottom: {
                  xs: '150px',
                  sm: '95px',
                },
              }}
            >
              <DataTable
                table={{ columns, rows }}
                isSorted={true}
                entriesPerPage={{ defaultValue: perPage }}
                showTotalEntries
                perPage={perPage}
                setPerPage={setPerPage}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalPage={notifications?.totalPage}
                totalRecords={notifications?.totalCount}
                hiddenColumns={['id']}
                isLoading={isLoading}
              />
            </MDBox>
          </Card>
        </Grid>
      </Grid>
      {openModal && (
        <AddEmail
          openModal={openModal}
          onCloseModal={onCloseModal}
          onCreateEmail={onCreateEmail}
        />
      )}
      {isPreviewModal && (
        <PreviewEmail
          openModal={isPreviewModal}
          onCloseModal={onCloseModal}
          selectedEmail={selectedEmail}
        />
      )}
    </MDBox>
  );
};

export default Email;
